module.exports = __webpack_public_path__ + "static/media/video-03-shelfzone.4839e3a1.mp4";